// extracted by mini-css-extract-plugin
export var boldText = "_62-4";
export var checkboxContainer = "_62-6";
export var closeIcon = "_62-i";
export var container = "_62-0";
export var drawer = "_62-8";
export var drawerContent = "_62-9";
export var extraSmallText = "_62-5";
export var fulfillmentGroupTable = "_62-e";
export var largeText = "_62-3";
export var loadingSpinnerContainer = "_62-j";
export var mediumText = "_62-2";
export var narrow = "_62-f";
export var notificationLink = "_62-l";
export var packageCheckIconContainer = "_62-7";
export var slideoutHeaderActions = "_62-g";
export var slideoutHeaderActionsShifted = "_62-h";
export var slideoutHeaderContainer = "_62-a";
export var slideoutModal = "_62-c";
export var stickyHeaderWrapper = "_62-b";
export var table = "_62-k";
export var tableContainer = "_62-d";
export var tertiaryText = "_62-1";